/* eslint-disable functional/no-conditional-statement */
import { useNavigate } from "../../common/hooks/useNavigate";
import { getCustomThankYouPageDetails } from "../../common/miscellaneous/getCustomThankYouPageDetails";
import { getPartnerPathnameClient } from "../../getPartnerPathnameClient";
import { useFindLocationPage } from "./useFindLocationPage";
import { useOrderValueData } from "./useOrderValueData";

export function useLockToOrderSuccessPage() {
  const navigate = useNavigate();
  const order = useOrderValueData();
  const pageFound = useFindLocationPage();
  const thankYouPageDetails = getCustomThankYouPageDetails();
  const errorRequired =
    order.tag === "ready" &&
    order.data.errors?.find((item) => {
      return item.errorCode === "RequiredApiNotAvailable";
    });

  if (!!errorRequired) {
    return;
  }

  if (
    order.data.status !== undefined &&
    order.data.status !== "Open" &&
    pageFound !== undefined &&
    pageFound.path !== "/success" &&
    order.data.errors?.length === 0
  ) {
    return thankYouPageDetails.allowRedirection ? null : navigate(`${getPartnerPathnameClient(true)}/success`);
  } else {
    return;
  }
}
